module.exports = __webpack_public_path__ + "img/avatar_random_7.514305b5.png";